import React from 'react';
import Styles from "../Styles.js";
import { needFlags } from "../util/flagcalc";
import { getFlagParams } from "../util/config";
import { PVMFLAG } from "../util/constants";
import { MEMBERREQUESTED, PROJECTDENIED, PROJECTCLOSED, PROJECTREQUESTED } from "../util/constants";

export function ProjectDetails(props) {
    let memberDetails = null;
    const {project, authuser, config, verify, remove, promote, navigate} = props;
    const isAdmin = authuser.roles.length > 0;
    const isactive = project.state !== PROJECTDENIED && project.state !== PROJECTCLOSED
    const is_pi = project.principal_investigator === authuser.id
    const piSignedMemberDocs = needFlags(project, authuser, config).switchPIflagsNeeded;
    const pstate = project.state ? project.state : PROJECTREQUESTED
    const now = Date.now()
    memberDetails = <div style={{width: "100%", margin: "50px auto 0", textAlign: "center"}}><table style={{border: "2px solid #000"}}>
      <tbody>
        <tr key="headings" className="member-details">
          <td className="headings-row">Member</td>
          <td className="headings-row">State</td>
          <td className="headings-row">Comment</td>
          <td className="headings-row">Missing Requirements</td>
          {isactive && is_pi && <td className="headings-row">Actions</td>}
        </tr>
        {project.member_details.map((member, idx) => {
          const flags = needFlags(project, member, config);
          const pi_row = project.principal_investigator === member.eppn
          const allrequired = flags.sflagsNeeded.concat(flags.pflagsNeeded, flags.uflagsNeeded)
          const state = member.state ? member.state : MEMBERREQUESTED
          let verifiable = flags.pvmflag ? true : false;
          const addable = flags.rmflag ? true : false;
          const removable = !addable;
          const memberSignedPIDocs = needFlags(project, member, config).switchPIflagsNeeded;
          let expire_days = null
          if (verifiable && removable) {
            const fe = getFlagParams(config, PVMFLAG);
            expire_days = Math.round(fe.expire_days - (now - (flags.pvmflag.mseconds * 1000)) / 3600000 / 24);
            if (expire_days >= fe.expire_days) {
              verifiable = false
            }
          }
          return <tr key={idx} className="member-details">
            <td>
              {member.display_name}<br/>
              {isAdmin
                ? <div className="log-link" onClick={() => navigate(`log/${props.project.id}-${member.eppn}`)}>{member.eppn}</div>
                : <div>{member.eppn}</div>}
            </td>
            <td>
              {config.member_states[state]}<br />
              {expire_days !== null && `(expire: ${expire_days} days)`}
            </td>
            <td>
                {member.comment ? member.comment : "(none)"}
            </td>
            <td>
                {allrequired.length === 0 ? "(none)" : allrequired.map((flag, idx) =>
                  <span key={idx}>
                    {flag}
                    <br />
                  </span>
                )}
            </td>
            {isactive && is_pi && !pi_row && <td>
              <ul>
                {verifiable && verify && <li onClick={() => verify(member.eppn)} style={{cursor: "pointer"}}><b>Verify</b></li>}
                {addable && verify && <li onClick={() => verify(member.eppn)} style={{cursor: "pointer"}}><b>Re-add</b></li>}
                {removable && remove && <li onClick={() => remove(member.eppn)} style={{cursor: "pointer"}}><b>Remove</b></li>}
                {piSignedMemberDocs.length === 0 && memberSignedPIDocs.length === 0 && <li onClick={() => promote(member.eppn)} style={{cursor: "pointer"}}><b>Promote to PI</b></li>}
              </ul>
            </td>}
            {isactive && is_pi && pi_row && <td> </td>}
          </tr>
        })}
      </tbody>
    </table></div>

    return (
    <Styles>
      <div className="project-details">
        <div>
          <h3>Project ID</h3>
          {isAdmin
            ? <div className="log-link" onClick={() => navigate(`log/${props.project.id}`)}>{props.project.id}</div>
            : <div>{props.project.id}</div>}
        </div>
        <div>
          <h3>Principal Investigator</h3>
          <p>{project.pi_display_name} / {project.principal_investigator}</p>
        </div>
        <div>
          <h3>State</h3>
          <p>{config.project_states[pstate]}</p>
        </div>
        {project.comment && <div>
          <h3>Comment</h3>
          <p>{project.comment}</p>
        </div>}
        {memberDetails}
      </div>
    </Styles>
    );
}
